<template>
	<nav class="navigation navbar navbar-default navbar-fixed-bottom">
		<div class="container-fluid justify-content-center ">
			<div class="navbar-header d-flex  ">
				<a
					href="https://github.com/rioparmar1996"
					id="menuTextLeft"
					class="option1 navbar-text navbar-left px-3"
					><i
						id="scale"
						class="icon-one fab fa-github fa-2x"
						aria-hidden="true"
					></i>
				</a>
				<a
					href="https://codepen.io/rioparmar1996"
					id="menuTextLeft"
					class="option2 navbar-text navbar-left px-3"
				>
					<i
						id="scale"
						class="icon-two fab fa-codepen fa-2x"
						aria-hidden="true"
					></i>
				</a>
				<a
					href="https://www.linkedin.com/in/ritesh-parmar/"
					id="menuTextLeft"
					class="option6 navbar-text navbar-left px-3"
				>
					<i
						id="scale"
						class="icon-three fab fa-linkedin-in fa-2x"
						aria-hidden="true"
					></i>
				</a>
				<a
					href="https://www.youtube.com/channel/UCnYt22WWbgMgOY68Y3Rbj-g"
					id="menuTextLeft"
					class="option6 navbar-text navbar-left px-3"
				>
					<i
						id="scale"
						class="icon-three fab fa-youtube fa-2x"
						aria-hidden="true"
					></i>
				</a>
				<a
					href="https://www.instagram.com/ritesh_parmar_1996/"
					id="menuTextLeft"
					class="option7 navbar-text navbar-left px-3"
				>
					<i
						id="scale"
						class="icon-three fab fa-instagram fa-2x"
						aria-hidden="true"
					></i>
				</a>
			</div>
		</div>
	</nav>
</template>

<script>
export default {};
</script>

<style scoped>
a {
	text-decoration: none;
}
#menuTextLeft {
	color: #333333;
	font-size: 16px;
	font-weight: 550;
}

.navigation {
	background: none !important;
	border: none;
	/* visibility: hidden; */
}
</style>
